export const getKanbanBoardColumns = (subTaskByStatusMap) => {
    const list = [];
    subTaskByStatusMap.forEach((values, key) => {
        list.push({
            id: key.toString(),
            itemIds: values.map(m => m.id),
        });
    });
    return list;
};
export const getSubTaskByStatusMap = (subTasks) => {
    if (!subTasks || subTasks.length === 0) {
        return new Map([
            [0, []],
            [1, []],
            [2, []],
        ]);
    }
    return subTasks.reduce((result, obj) => {
        const subTasksByStatusArray = result.get(obj.status);
        if (subTasksByStatusArray) {
            result.set(obj.status, [...subTasksByStatusArray, obj]);
        }
        else {
            result.set(obj.status, [obj]);
        }
        return result;
    }, new Map([
        [0, []],
        [1, []],
        [2, []],
    ]));
};
export const getItemStyle = (isDragging, draggableStyle) => (Object.assign({}, draggableStyle));
export const getContainerListStyle = () => ({
    height: '100%',
    width: '100%',
});
export const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? '#dfddeb' : undefined,
    border: isDraggingOver ? '4px dashed #7564b6' : undefined,
    width: '100%',
    minHeight: '100%',
});
export const getUser = (userId, users) => users && userId ? users.find(x => x.id === userId) : null;
